import { VAR_TYPES } from "constants/constants";

export const ifValueSet = (value, type) => {
  if (value === null || value === undefined) {
    return false;
  } else if (isNaN(value) && type === VAR_TYPES.NUMBER) {
    return value.length > 0;
  } else {
    return value.toString().length > 0;
  }
};
